import { triggerHousekeepingRoomsRefresh } from "store/slice/pusherSlice";
import { getPusherClient } from "./pusherClient";

import {
  addNotification,
  clearPusherSubscriptionState,
  setPusherConnected,
  setSubscribedHotelChannel,
  setSubscribedUserChannel,
} from "store/slice/pusherSlice";

let hotelChannel = null;
let userChannel = null;

export const subscribeToHousekeepingPusher = ({
  hotelId,
  userId,
  dispatch,
  onRoomAdded,
  onRoomDeleted,
  onRoomUpdated,
  onAssignmentChanged,
  onStatusChanged,
  onNoteChanged,
}) => {
  if (!hotelId || !userId) {
    return null;
  }

  const pusher = getPusherClient();

  const hotelChannelName = `private-hk-hotel-${hotelId}`;
  const userChannelName = `private-hk-user-${userId}`;

  dispatch(setPusherConnected(true));

  /*
   * HOTEL CHANNEL
   *
   * Internal UI synchronization only.
   */
  hotelChannel = pusher.subscribe(hotelChannelName);

  dispatch(setSubscribedHotelChannel(hotelChannelName));

  /*
   * USER CHANNEL
   *
   * Personal notifications.
   */
  userChannel = pusher.subscribe(userChannelName);

  dispatch(setSubscribedUserChannel(userChannelName));

  // ==========================================
  // INTERNAL HOUSEKEEPING EVENTS
  // ==========================================
  hotelChannel.bind("hk.room.added", (data) => {
    dispatch(triggerHousekeepingRoomsRefresh());
    onRoomAdded?.(data);
  });

  hotelChannel.bind("hk.room.deleted", (data) => {
    dispatch(triggerHousekeepingRoomsRefresh());
    onRoomDeleted?.(data);
  });

  hotelChannel.bind("hk.room.updated", (data) => {
    dispatch(triggerHousekeepingRoomsRefresh());
    onRoomUpdated?.(data);
  });

  hotelChannel.bind("hk.assignment.changed", (data) => {
    dispatch(triggerHousekeepingRoomsRefresh());
    onAssignmentChanged?.(data);
  });

  hotelChannel.bind("hk.status.changed", (data) => {
    dispatch(triggerHousekeepingRoomsRefresh());
    onStatusChanged?.(data);
  });

  hotelChannel.bind("hk.note.changed", (data) => {
    dispatch(triggerHousekeepingRoomsRefresh());
    onNoteChanged?.(data);
  });

  // ==========================================
  // PERSONAL NOTIFICATIONS
  // ==========================================

  userChannel.bind("hk.notification", (notification) => {
    const notificationId = notification?._id || notification?.id;

    if (!notificationId) {
      return;
    }

    dispatch(
      addNotification({
        ...notification,
        _id: notificationId,
        isRead: notification?.isRead ?? false,
      })
    );
  });

  // ==========================================
  // CLEANUP
  // ==========================================

  return () => {
    if (hotelChannel) {
      hotelChannel.unbind_all();

      pusher.unsubscribe(hotelChannelName);

      hotelChannel = null;
    }

    if (userChannel) {
      userChannel.unbind_all();

      pusher.unsubscribe(userChannelName);

      userChannel = null;
    }

    dispatch(clearPusherSubscriptionState());
  };
};

// -------------------------------------------------------------------- FOR DEBUGGING ---------------------------------------------------------------------

// import { getPusherClient } from "./pusherClient";

// import {
//   addNotification,
//   clearPusherSubscriptionState,
//   setPusherConnected,
//   setSubscribedHotelChannel,
//   setSubscribedUserChannel,
// } from "store/slice/pusherSlice";

// let hotelChannel = null;
// let userChannel = null;

// export const subscribeToHousekeepingPusher = ({
//   hotelId,
//   userId,
//   dispatch,
//   onRoomAdded,
//   onRoomDeleted,
//   onRoomUpdated,
//   onAssignmentChanged,
//   onStatusChanged,
//   onNoteChanged,
// }) => {
//   console.log("========================================");
//   console.log("🚀 subscribeToHousekeepingPusher CALLED");
//   console.log("hotelId:", hotelId);
//   console.log("userId:", userId);
//   console.log("========================================");

//   if (!hotelId || !userId) {
//     console.warn("⚠️ PUSHER SUBSCRIPTION SKIPPED", {
//       hotelId,
//       userId,
//     });

//     return null;
//   }

//   const pusher = getPusherClient();

//   console.log("🔌 Pusher client:", pusher);
//   console.log("🔌 Current connection state:", pusher?.connection?.state);
//   console.log("🔌 Current socket ID:", pusher?.connection?.socket_id);

//   const hotelChannelName = `private-hk-hotel-${hotelId}`;
//   const userChannelName = `private-hk-user-${userId}`;

//   console.log("🏨 Hotel channel name:", hotelChannelName);
//   console.log("👤 User channel name:", userChannelName);

//   const connectedAction = setPusherConnected(true);

//   console.log("📤 Dispatching setPusherConnected:", connectedAction);

//   dispatch(connectedAction);

//   /*
//    * HOTEL CHANNEL
//    */
//   hotelChannel = pusher.subscribe(hotelChannelName);

//   console.log("🏨 Hotel subscribe() returned:", hotelChannel);

//   dispatch(setSubscribedHotelChannel(hotelChannelName));

//   /*
//    * USER CHANNEL
//    */
//   userChannel = pusher.subscribe(userChannelName);

//   console.log("👤 User subscribe() returned:", userChannel);

//   dispatch(setSubscribedUserChannel(userChannelName));

//   // ==========================================
//   // CONNECTION DEBUGGING
//   // ==========================================

//   pusher.connection.bind("state_change", (states) => {
//     console.log("🔄 PUSHER CONNECTION STATE CHANGE:", states);
//   });

//   pusher.connection.bind("connected", () => {
//     console.log("✅ PUSHER CONNECTED");
//     console.log("Socket ID:", pusher.connection.socket_id);
//   });

//   pusher.connection.bind("disconnected", () => {
//     console.log("⚠️ PUSHER DISCONNECTED");
//   });

//   pusher.connection.bind("error", (error) => {
//     console.error("❌ PUSHER CONNECTION ERROR:", error);
//   });

//   // ==========================================
//   // USER CHANNEL DEBUGGING
//   // ==========================================

//   userChannel.bind("pusher:subscription_succeeded", () => {
//     console.log("========================================");
//     console.log("✅ USER CHANNEL SUBSCRIBED");
//     console.log("Channel:", userChannelName);
//     console.log("========================================");
//   });

//   userChannel.bind("pusher:subscription_error", (error) => {
//     console.error("========================================");
//     console.error("❌ USER CHANNEL SUBSCRIPTION ERROR");
//     console.error("Channel:", userChannelName);
//     console.error("Error:", error);
//     console.error("========================================");
//   });

//   userChannel.bind_global((eventName, data) => {
//     console.log("========================================");
//     console.log("🔥 USER CHANNEL EVENT RECEIVED");
//     console.log("Event name:", eventName);
//     console.log("Raw data:", data);
//     console.log("data.id:", data?.id);
//     console.log("data._id:", data?._id);
//     console.log("data.isRead:", data?.isRead);
//     console.log("data.type:", data?.type);
//     console.log("data.payload:", data?.payload);
//     console.log("========================================");
//   });

//   // ==========================================
//   // HOTEL CHANNEL DEBUGGING
//   // ==========================================

//   hotelChannel.bind("pusher:subscription_succeeded", () => {
//     console.log("========================================");
//     console.log("✅ HOTEL CHANNEL SUBSCRIBED");
//     console.log("Channel:", hotelChannelName);
//     console.log("========================================");
//   });

//   hotelChannel.bind("pusher:subscription_error", (error) => {
//     console.error("========================================");
//     console.error("❌ HOTEL CHANNEL SUBSCRIPTION ERROR");
//     console.error("Channel:", hotelChannelName);
//     console.error("Error:", error);
//     console.error("========================================");
//   });

//   hotelChannel.bind_global((eventName, data) => {
//     console.log("========================================");
//     console.log("🏨 HOTEL CHANNEL EVENT RECEIVED");
//     console.log("Event name:", eventName);
//     console.log("Event data:", data);
//     console.log("========================================");
//   });

//   // ==========================================
//   // INTERNAL HOUSEKEEPING EVENTS
//   // ==========================================

//   hotelChannel.bind("hk.room.added", (data) => {
//     console.log("➕ hk.room.added handler called:", data);

//     onRoomAdded?.(data);
//   });

//   hotelChannel.bind("hk.room.deleted", (data) => {
//     console.log("🗑️ hk.room.deleted handler called:", data);

//     onRoomDeleted?.(data);
//   });

//   hotelChannel.bind("hk.room.updated", (data) => {
//     console.log("🔄 hk.room.updated handler called:", data);

//     onRoomUpdated?.(data);
//   });

//   hotelChannel.bind("hk.assignment.changed", (data) => {
//     console.log("👤 hk.assignment.changed handler called:", data);

//     onAssignmentChanged?.(data);
//   });

//   hotelChannel.bind("hk.status.changed", (data) => {
//     console.log("🧹 hk.status.changed handler called:", data);

//     onStatusChanged?.(data);
//   });

//   hotelChannel.bind("hk.note.changed", (data) => {
//     console.log("📝 hk.note.changed handler called:", data);

//     onNoteChanged?.(data);
//   });

//   // ==========================================
//   // PERSONAL NOTIFICATIONS
//   // ==========================================

//   userChannel.bind("hk.notification", (notification) => {
//     console.log("========================================");
//     console.log("🔔 hk.notification HANDLER CALLED");
//     console.log("Notification received:", notification);

//     const notificationId = notification?._id || notification?.id;

//     console.log("Resolved notification ID:", notificationId);

//     if (!notificationId) {
//       console.error("❌ Notification has no id or _id. Redux dispatch will likely ignore it.");
//     }

//     const normalizedNotification = {
//       ...notification,
//       _id: notificationId,
//       isRead: notification?.isRead ?? false,
//     };

//     console.log("Normalized notification before Redux:", normalizedNotification);

//     const action = addNotification(normalizedNotification);

//     console.log("📦 Redux addNotification action:", action);

//     const dispatchResult = dispatch(action);

//     console.log("📤 Redux dispatch result:", dispatchResult);

//     console.log("✅ addNotification dispatch completed");

//     console.log("========================================");
//   });

//   // ==========================================
//   // CLEANUP
//   // ==========================================

//   return () => {
//     console.log("========================================");
//     console.log("🧹 CLEANING UP PUSHER SUBSCRIPTIONS");
//     console.log("Hotel:", hotelChannelName);
//     console.log("User:", userChannelName);
//     console.log("========================================");

//     if (hotelChannel) {
//       console.log("🏨 Unbinding hotel channel:", hotelChannelName);

//       hotelChannel.unbind_all();

//       pusher.unsubscribe(hotelChannelName);

//       hotelChannel = null;
//     }

//     if (userChannel) {
//       console.log("👤 Unbinding user channel:", userChannelName);

//       userChannel.unbind_all();

//       pusher.unsubscribe(userChannelName);

//       userChannel = null;
//     }

//     console.log("📤 Clearing Redux subscription state");

//     dispatch(clearPusherSubscriptionState());
//   };
// };
